// window.cateData.isShowLoading = true; //页面需要loading加载数据
var campaignPagee2023cloudPlatModule = {
    tabCon: null, // Tab容器
    tabList: null, // 所有的tab标签
    tabConTop: 0, // Tab容器距离顶部距离
    header: null, // 网站顶部
    isScrolling: false, // 是否正在滚动
    secondTabList: null,
    secondTabConList: null,
    curShowCount: 4,

    init: function () {
        this.tabCon = document.querySelector('.template-acq-tab-container');
        this.tabConTop = this.tabCon.offsetTop;
        this.tabList = document.querySelectorAll('.template-acq-tabs a');
        this.secondTabList = document.querySelectorAll('.template-acq-select-tab-tab1');
        this.secondTabConList = document.querySelectorAll('.template-acq-select-content1');
        this.header = document.querySelector('.topbar');
        this.initTab();
        this.initVue();
    },
    /* 初始化Tab */
    initTab: function () {
        var _this = this;
        for (var idx = 0; idx < _this.tabList.length; idx++) {
            _this.tabList[idx].index = idx;
            _this.tabList[idx].onclick = function () {
                var target = document.getElementById(this.hash.slice(1));
                if (!target) return;
                for (var k = 0; k < _this.tabList.length; k++) {
                    _this.tabList[k].parentElement.classList.remove('active-tab');
                }
                this.parentElement.classList.add('active-tab');

                var targetOffsetTop = target.offsetTop - _this.header.offsetHeight - _this.tabCon.offsetHeight;

                if (!_this.tabCon.classList.contains('fixed-tab')) {
                    targetOffsetTop = targetOffsetTop - _this.tabCon.offsetHeight;
                }

                _this.isScrolling = true;
                $('html, body').animate({scrollTop: targetOffsetTop}, 1000, 'linear', function () {
                    _this.isScrolling = false;
                });
                return false;
            }
        }
        for (var i = 0; i < _this.secondTabList.length; i++) {
            _this.secondTabList[i].index=i;
            // 选择云平台的tab的切换
            _this.secondTabList[i].onclick = function () {
                for (var x = 0; x < _this.secondTabList.length; x++) {
                    _this.secondTabList[x].classList.remove('template-acq-select-active');
                }
                this.classList.add('template-acq-select-active');
                // 旁边的元素的对应切换
                for (var y = 0; y < _this.secondTabConList.length; y++) {
                    _this.secondTabConList[y].classList.remove('template-acq-select-content-active');
                }
                _this.secondTabConList[this.index].classList.add('template-acq-select-content-active');
            }
        }
    },
    /* 滚动定位和固定Tab到顶部 */
    scrollLocate: function () {
        var _this = this;
        _this.tabConTop = document.querySelector('.template-acq-tab-container').offsetTop; // 实时获取一下元素距离顶部的距离
        var oScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if (oScrollTop > _this.tabConTop) {
            _this.tabCon.classList.add('fixed-tab');
            !common.getCookie('serverSuccessDialog') && !common.getSS('serverSuccessDialog');
        } else {
            _this.tabCon.classList.remove('fixed-tab');
        }

        // 滚动完成后再去计算tab选中
        if (!_this.isScrolling) {
            for (var idx = 0; idx < _this.tabList.length; idx++) {
                _this.tabList[idx].parentElement.classList.remove('active-tab');
                var target = document.getElementById(_this.tabList[idx].hash.slice(1));
                if (!target) return;

                // targetTop 目标距离顶部距离，targetBottom 目标底部距离页面顶部距离
                var targetTop = target.offsetTop - 80;
                var targetBottom = target.offsetTop + target.offsetHeight - _this.header.offsetHeight - 10;

                targetTop = targetTop - _this.tabCon.offsetHeight;
                targetBottom = targetBottom - _this.tabCon.offsetHeight;
                if (!_this.tabCon.classList.contains('fixed-tab')) {
                    targetTop = targetTop - 55;
                }

                // 高度容错
                targetTop -= 95;
                targetBottom -= 95;

                if (oScrollTop >= targetTop && oScrollTop < targetBottom) {
                    _this.tabList[idx].parentElement.classList.add('active-tab');
                }

            }
            // tab没有固定之前默认第一个选中
            if (!_this.tabCon.classList.contains('fixed-tab')) {
                _this.tabList[0].parentElement.classList.add('active-tab');
            }
        }
    },
    /* 调用接口 */
    initVue: function () {
        new Vue({
            el: '#helpCenter',
            data: function() {
                return {
                    questionList: []
                };
            },
            mounted:function() {
                this.getquestionLists();
            },
            methods: {
                getquestionLists: function(){
                    var _this = this;
                    $.ajax({
                        url: window.solution_host + "/api/campaign/apex/qaList",
                        method: 'GET',
                        data: {},
                        success:function (res) {
                            _this.questionList=res.data;
                            console.log(_this.questionList,'???');
                        },
                        error: function (error) {
                            console.log(error,'error');
                        }
                    });
                },
                submitQuestion: function() {
                    var names = $('#name').val();
                    var mobiles = $('#mobile').val();
                    var emails = $('#email').val();
                    var companys = $('#company').val();
                    var questions = $('#question').val();
                    if(!names){
                        msg.toast('请输入您的姓名');
                        return;
                    }
                    if(mobiles){
                        if (!baseVerif.isMobile(mobiles)){
                            msg.toast('请输入正确的手机号');
                            return;
                        }
                    }
                    if(!emails){
                        msg.toast('请输入您的邮箱');
                        return;
                    }
                    if(!companys){
                        msg.toast('请输入您的公司名称');
                        return;
                    }
                    if(!questions){
                        msg.toast('请输入您的问题');
                        return;
                    }
                    if (!baseVerif.isEmail(emails)){
                        msg.toast('请输入正确的邮箱');
                        return;
                    }
                    var params={
                        name:names,
                        mobile:mobiles,
                        email:emails,
                        company:companys,
                        question:questions
                    };
                    $.ajax({
                        url: window.solution_host + "/api/campaign/apex/question",
                        method: 'POST',
                        data: params,
                        success:function (res) {
                            if(res.errCode === 0){
                                //用户行为：记录提交APEX云平台疑惑表单
                                userRecode({behaviorType: '提交表单', behaviorResult: 'APEX云平台疑惑-提交成功',});
                                msg.toast('提交成功');
                                $('#name').val('');$('#mobile').val('');$('#email').val('');$('#company').val('');$('#question').val('');
                            }else {
                                msg.toast(res.msg);
                            }
                        },
                        error: function (error) {
                            msg.toast('提交失败');
                        }
                    });
                }
            }
        });
    }
};
campaignPagee2023cloudPlatModule.init();
window.onscroll = function() {
    campaignPagee2023cloudPlatModule.scrollLocate();
};
